import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { CheckCircle2, XCircle, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { GoogleButton, googleRedirect, takeSessionId } from "@/components/GoogleButton";

const Row = ({ ok, label, testid }) => (
  <div className="flex items-center gap-2 text-sm" data-testid={testid}>{ok ? <CheckCircle2 size={16} className="text-[#2f8a4c]" /> : <XCircle size={16} className="text-[#c0392b]" />}<span className="text-navy font-medium">{label}</span><span className="text-[#6b7a8c]">{ok ? "bağlı" : "anahtar yok"}</span></div>
);

export function ImageKeysCard() {
  const loc = useLocation();
  const done = useRef(false);
  const [k, setK] = useState(null);
  const load = () => api.get("/system/image-keys").then((r) => setK(r.data));
  useEffect(() => {
    const sid = !done.current && takeSessionId(loc.hash);
    if (sid) {
      done.current = true;
      api.post("/auth/google/link", { session_id: sid }).then((r) => toast.success(`${r.data.google_email} bağlandı`)).catch((e) => toast.error(errMsg(e))).finally(load);
    } else load();
  }, [loc.hash]);
  const unlink = async () => { await api.delete("/auth/google/link"); toast.success("Google bağlantısı kaldırıldı"); load(); };
  if (!k) return null;
  return (
    <div className="card-z p-5 mb-5 grid md:grid-cols-2 gap-6" data-testid="image-keys-card">
      <div>
        <div className="flex items-center gap-2 font-serif-d text-xl text-navy mb-1"><KeyRound size={18} /> Görsel üretim anahtarları</div>
        <p className="text-sm text-[#5f6f84] mb-3">Görseller Emergent Universal Key ile (bakiyenizden) üretilir; sorun olursa kendi Gemini, ardından OpenAI anahtarınız denenir. Uygulamada adet sınırı yoktur.</p>
        <div className="space-y-1.5"><Row ok={k.providers.includes("universal")} label="Emergent Universal Key (ana)" testid="key-status-universal" /><Row ok={k.providers.includes("gemini")} label="Google Gemini (yedek)" testid="key-status-gemini" /><Row ok={k.providers.includes("openai")} label="OpenAI (yedek)" testid="key-status-openai" /></div>
      </div>
      <div>
        <div className="font-serif-d text-xl text-navy mb-1">Google ile giriş</div>
        {k.google_email ? <>
          <p className="text-sm text-[#5f6f84] mb-3">Bağlı hesap: <b className="text-navy" data-testid="google-linked-email">{k.google_email}</b>. Giriş ekranında "Google ile giriş yap" ile girebilirsiniz.</p>
          <button onClick={unlink} className="btn-ghost px-3 py-2 text-sm" data-testid="google-unlink-btn">Bağlantıyı kaldır</button>
        </> : <>
          <p className="text-sm text-[#5f6f84] mb-3">Google hesabınızı bu kullanıcıya bağlayın; sonra giriş ekranından tek tıkla girersiniz.</p>
          <div className="max-w-[300px]"><GoogleButton onClick={() => googleRedirect("/ayarlar/api")} label="Google hesabımı bağla" testid="google-link-btn" /></div>
        </>}
      </div>
    </div>
  );
}
